module.exports = __webpack_public_path__ + "static/img/dia-del-nino-3.59ac690.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/dia-del-nino-3.jpg
// module id = qC0t
// module chunks = 1